export function transformSubcategoriesIntoCategories(category) {
  const newCategories = {};
  // eslint-disable-next-line array-callback-return
  category.map(subcategory => {
    if (newCategories[subcategory.properties.type]) {
      newCategories[subcategory.properties.type].push(subcategory);
    } else {
      newCategories[subcategory.properties.type] = [subcategory];
    }
  });
  return newCategories;
}

export const emptyParams = {
  type: '',
  status: '',
  company: '',
  search: '',
  page: 0,
  size: 10,
  sortBy: [{ id: 'last_interaction', desc: true }]
};
